export type SidebarRoutePolicy = 'expand' | 'collapse' | 'preserve';

function normalizeUrl(url: string): string {
  const withoutQuery = url.split('?')[0];
  if (withoutQuery === '/') {
    return '/';
  }
  return withoutQuery.replace(/\/+$/, '');
}

function isInvestmentContextRoute(normalizedUrl: string): boolean {
  if (!normalizedUrl.startsWith('/home/investments/')) {
    return false;
  }

  return normalizedUrl !== '/home/investments/create';
}

function isMediaRoute(normalizedUrl: string): boolean {
  return normalizedUrl === '/home/media' || normalizedUrl.startsWith('/home/media/');
}

export function resolveSidebarRoutePolicy(url: string): SidebarRoutePolicy {
  const normalizedUrl = normalizeUrl(url);

  if (isInvestmentContextRoute(normalizedUrl) || isMediaRoute(normalizedUrl)) {
    return 'collapse';
  }

  return 'preserve';
}
